import React, { useContext, useState } from "react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import _ from "lodash";
import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import firebase from "../../firebase";
import config from "../../config";

const CropClasses = ({ classes, crops, userState }) => {
  const language = useContext(LanguageContext);
  const [isMore, setIsMore] = useState(true);
  const [cropNumber, setCropNumber] = useState(9);

  const userStateName = userState
    ? userState.name_en.toLowerCase()
    : "maharashtra";

  crops = _.filter(crops, (crop) => {
    if (
      crop.visible &&
      crop.states.find((state) => state.name === userStateName)
    ) {
      return crop;
    }
  });
  crops.sort((crop1, crop2) => {
    const crop1State = crop1.states.find(
      (state) => state.name === userStateName
    );
    const crop2State = crop2.states.find(
      (state) => state.name === userStateName
    );
    return crop1State.position - crop2State.position;
  });

  const onclickCropsButton = () => {
    setIsMore(!isMore);
    setCropNumber(isMore ? crops.length : 9);
    let event = isMore ? "see_more_crops_clicked" : "see_less_crops_clicked";
    firebase.analytics().logEvent(event, {
      state_name: userState ? userState.name_en.toLowerCase() : "maharashtra",
    });
  };

  return (
    <div className={classes.greySection}>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>
          <Typography
            align={"center"}
            variant={"h6"}
            style={{ fontWeight: "bold" }}
          >
            {messages["landing.cropTitle"][language]}
          </Typography>
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item xs={12} md={8}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            {crops &&
              crops.length > 0 &&
              crops.slice(0, cropNumber).map((crop, index) => {
                return (
                  <Grid
                    item
                    xs={4}
                    md={3}
                    key={index}
                    style={{ margin: "1vh 0vh" }}
                  >
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      style={{ margin: "1vh 0vh" }}
                    >
                      <Grid item>
                        <Avatar
                          aria-label={crop.name_en}
                          src={`${
                            config.gcpBucketBase
                          }content${encodeURIComponent(
                            crop.image_thumbnail
                          )}?alt=media`}
                          className={classes.cropThumbnail}
                          alt={crop.name_en}
                        >
                          {crop.name_en}
                        </Avatar>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>{crop[`name_${language}`]}</Grid>
                    </Grid>
                  </Grid>
                );
              })}
          </Grid>
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>
          <Button
            onClick={onclickCropsButton}
            size={"large"}
            style={{
              color: "#9D2123",
              background: "#fff",
              margin: "3vh",
            }}
            variant={"contained"}
            endIcon={isMore ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
          >
            {isMore
              ? messages["landing.seeMoreCrops"][language]
              : messages["landing.seeLessCrops"][language]}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default CropClasses;
